// @flow

import type {Language, EventRuleChange, EventRuleGroup} from '@/types'
import React, {Component} from 'react'
import {connect} from 'react-redux'
import {always, forEach, map, values, filter} from 'ramda'
import {activeInRules, ruleOff, toggleAllWhere, toggleAnyWhere, ruleOn, toggleSubAllWhere} from '@/rules-helper'
import {appSelectors} from '@/store'
import SubRule from './sub-rules-group'
import Rule from './rule'

type Props = {
  l: Language,
  group: EventRuleGroup,
  onChange: (EventRuleChange) => void,
  change: false,
}
export class RawComplexGroup extends Component<Props, *> {
  update = (groupName: string, subRules: Object) => (r: EventRuleChange) => {
    const isSubGroupPresent = (subGroups) => (subGroups && subGroups.length > 0 && r.ruleCode !== 501)
    let checkSubRules = isSubGroupPresent(this.props.group.rules.subGroups)
    let count = 0
    let rules, allRule, anyRule
    if (checkSubRules) {
      // If sub groups and sub group rules present
      rules = values(subRules.subGroupRules)
      allRule = subRules.allRuleCode
      anyRule = subRules.anyRuleCode
    } else {
      rules = values(this.props.group.notificationRules)
      allRule = this.props.group.groupInfo.allRuleCode
      anyRule = this.props.group.groupInfo.anyRuleCode
    }
    let calculateChanges
    if (r.ruleCode === allRule) {
      if (checkSubRules) {
        // Toggle allRuleCode if Sub group rules having 'All Rule Code'
        calculateChanges = toggleSubAllWhere(allRule, anyRule)
      } else {
        // Toggle allRule Code in Notification rules
        calculateChanges = toggleAllWhere(allRule, anyRule)
      }
    } else if (r.ruleCode === anyRule) {
      calculateChanges = toggleAnyWhere(allRule, anyRule)
    } else {
      // Normal change - turn the any rule off since we are now being specific
      if (anyRule && activeInRules(anyRule)(rules)) {
        calculateChanges = always([r, ruleOff(anyRule)])
      } else {
        // check if all checkbox needs to be checked/unchecked
        const filteredRules = filter((rule) => {
          return !(rule.ruleCode === allRule || rule.ruleCode === anyRule)
        }, rules)
        let allChecked = 1
        forEach((rule) => {
          if (rule.ruleCode === r.ruleCode) {
            allChecked = allChecked && r.val
          } else {
            allChecked = allChecked && rule.isActive
          }
        }, filteredRules)
        let ruleChanges
        if (allRule) {
          ruleChanges = [r, allChecked ? ruleOn(allRule) : ruleOff(allRule)]
        } else {
          ruleChanges = [r]
        }
        calculateChanges = always(ruleChanges)
      }
    }
    const changes = calculateChanges(rules)
    if (checkSubRules) {
      for (let i = 0; i < changes.length; i++) {
        if (changes[i].val === 1) count++
        changes[i].check = true
        changes[i].subGroupName = groupName
        changes[i].subGroupAllRules = this.props.group.subGroupRules
        changes[i].count = count
        this.props.onChange(changes[i])
      }
    } else {
      if (r.ruleCode === 501) {
        for (let i = 0; i < changes.length; i++) {
          if (changes[i].val === 1) count++
          changes[i].check = false
          changes[i].count = count
          this.props.onChange(changes[i])
        }
        let eventRuleChange = {}
        map((subGroupRules) => {
          map((rules) => {
            if (r.val === 1) count++
            eventRuleChange = {
              ruleCode: rules.ruleCode,
              prop: 'isActive',
              val: r.val,
              check: true,
              subGroupAllRules: this.props.group.subGroupRules,
              subGroupName: subGroupRules.name,
              count: count,
            }
            this.props.onChange(eventRuleChange)
          }, subGroupRules.subGroupRules)
        }, this.props.group.subGroupRules)
      } else {
        for (let i = 0; i < changes.length; i++) {
          if (changes[i].val === 1) count++
          changes[i].check = false
          changes[i].count = count
          this.props.onChange(changes[i])
        }
      }
    }
  }
  checkSubGroups = (subGroups: any) => subGroups.length > 0
  renderSubGroups = (subGroups: any) => {
    return <SubRule key={subGroups.name} subGroups={subGroups} update={this.update}
      onChange={this.props.onChange} group={this.props.group}/>
  }
  render = () =>
    this.checkSubGroups(this.props.group.rules.subGroups)
      ? <div className='rule-group-section'>
        <label className='rule-group-name'>{this.props.l(this.props.group.groupInfo.name)}</label>
        {map(
          (r) => <Rule key={r.ruleCode} rule={r} onChange={this.update('', {})} />,
          values(this.props.group.notificationRules)
        )}
        {map(this.renderSubGroups,
          values(this.props.group.subGroupRules)
        )}
      </div>
      : <div className='rule-group-section'>
        <label>{this.props.l(this.props.group.groupInfo.name)}</label>
        {map(
          (r) => <Rule key={r.ruleCode} rule={r} onChange={this.update('', {})} />,
          values(this.props.group.notificationRules)
        )}
      </div>
}

const mapStateToProps = (state) => ({
  l: appSelectors.getL(state),
})

export default connect(
  mapStateToProps,
)(RawComplexGroup)



// WEBPACK FOOTER //
// ./src/views/settings-page/rules/complex-group.js